export function isAppPageRoute(route) {
    return route.endsWith("/page");
}

//# sourceMappingURL=is-app-page-route.js.map